import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Grid, Form, Button } from 'semantic-ui-react';
import { MealApproveAccepterResult } from 'components/MealApproveList';
import cm from 'helpers/commons';
import update from 'react-addons-update';
import toastr from 'helpers/toastr';

import { Division, SearchInputBox } from 'components/Commons';

class AddAccepterModal extends Component {
  constructor() {
    super();

    this.state = {
      type: null,
      text: null,
      accepterChecked: []
    };
  }

  componentDidUpdate() {
    const { accepterChecked } = this.state;
    if (accepterChecked.length > 0) {
      setTimeout(() => {
        accepterChecked.forEach((data) => {
          $('#' + data.id).prop('checked', true);
        });
      }, 300);
    }
  }

  changeText = (e, data) => {
    if (data.value.length > 100) {
      toastr('top-right', 'warning', '100자 이하로 입력해주세요.');
      return;
    } else {
      this.setState({ text: data.value });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { accepterChecked, type } = this.state;
    if (accepterChecked.length > 0) {
      const { acceptersAdd, modalFn } = this.props;
      const temp = accepterChecked;
      this.closeModal();
      // this.setState({ accepterChecked: [] });
      await acceptersAdd(temp, type);
    } else {
      toastr('top-right', 'warning', '사용자를 선택하세요.');
      return;
    }
  };

  handleAccepterChecked = async (type, isChecked, setData) => {
    const { accepterChecked } = this.state;
    const checkedMap = cm.excludeUseMap(accepterChecked);
    if (type === 'all') {
      if (isChecked) {
        if (accepterChecked) {
          for (let i = 0; i < setData.length; i++) {
            if (checkedMap.get(setData[i].id)) {
              setData.splice(i, 1);
              i--;
            }
          }
          setData = setData.concat(accepterChecked);
          this.setState({ type: 'all' });
        }
        await this.setState({ accepterChecked: setData });
      } else {
        const detData = cm.removeDup(accepterChecked, setData, 'id');
        await this.setState({ accepterChecked: detData });
      }
    } else {
      if (checkedMap && checkedMap.get(setData.id)) {
        const detData = cm.removeDup(accepterChecked, [setData], 'id');
        await this.setState({
          accepterChecked: detData
        });
      } else {
        await this.setState({
          type: null,
          accepterChecked: update(this.state.accepterChecked, {
            $push: [setData]
          })
        });
      }
    }
  };
  submitForm = async () => {
    const { staffSel, keyword, depth } = this.props;
    const params = {
      keyword: keyword ? keyword.value : null,
      orgCode: depth ? depth.value : null
    };
    staffSel(params);
  };
  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm();
    }
  };

  closeModal = () => {
    const { closeModal } = this.props.modalFn;
    this.setState({ accepterChecked: [] });
    $('.staff-checkbox').prop('checked', false);
    closeModal();
  };
  render() {
    const { accepterChecked } = this.state;
    const { acceptersMap, staffList, authApproveInfo, division, modalFn } = this.props;
    const { open, closeModal } = modalFn;

    let allUserCnt = 0;
    if (staffList && staffList.data) {
      allUserCnt = staffList.data.user ? staffList.data.user.length : 0;
    }

    return (
      <Modal
        className="reject-modal"
        size={'large'}
        dimmer={open}
        open={open}
        onClose={this.closeModal}
        style={{ height: 820 }}
      >
        <Modal.Header>사용자 추가</Modal.Header>

        <Modal.Content style={{ lineHeight: 'normal' }}>
          <Grid reversed="tablet vertically">
            <Grid.Row className="">
              <Grid.Column>
                <Form>
                  <Form.Group>
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 'bold',
                        lineHeight: 2,
                        marginRight: 10
                      }}
                    >
                      {`${accepterChecked.length} 명 / ${allUserCnt} 명`}
                    </span>
                    <SearchInputBox
                      handleSubmit={this.submitForm}
                      handleEntSubmit={(e) => this.handleEntSubmit(e)}
                      placeHolder={'ID, 이름'}
                    />
                    <Division
                      division={division}
                      style={{ position: 'fixed', zIndex: 999 }}
                      onChangeFunc={this.submitForm}
                    />
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <MealApproveAccepterResult
            checkInput
            isModal
            approveAccepterList={staffList}
            acceptersMap={acceptersMap}
            authApproveInfo={authApproveInfo}
            accepterChecked={accepterChecked}
            handleAccepterChecked={this.handleAccepterChecked}
          />
        </Modal.Content>

        <Modal.Actions>
          <Button inverted color="grey" onClick={this.closeModal} content="취소" />
          <Button positive content="확인" onClick={this.handleSubmit} />
        </Modal.Actions>
      </Modal>
    );
  }
}

AddAccepterModal = connect((state) => ({
  staffList: state.commons.staff,
  division: state.commons.division,
  orgCode: state.commons.orgIdx,
  depth: state.commons.depth,
  keyword: state.commons.text
}))(AddAccepterModal);

export default AddAccepterModal;
